<template>
  <div>
    <admin-filter
      :items="filterData"
      :itemFiltered.sync="filtered"
      @getData="getDataFromServer"
      title="정산 완료 조회"
      desc="정산 완료로 들어온 내역을 조회할 수 있습니다."
    ></admin-filter>

    <admin-table :field_list="tableData"
                 :items="tableItems"
                 :filtered="filtered"
                 :allCount="allCount"
                 :filteredCount="filteredCount"
                 :table_width="1400"
                 @getData="getDataFromServer"
                 @ordering="ordering"
                 @selPageLength="selPageLength">

      <div slot="partner_name" slot-scope="props">
        {{ props.item.partner_name }}
      </div>

      <div slot="acc_date" slot-scope="props">{{ props.item.acc_date }}</div>

      <div slot="total_price" slot-scope="props">
        {{ props.item.total_price | currency }}
      </div>

      <div slot="comm_price" slot-scope="props">
        {{ props.item.comm_price | currency }}
      </div>

      <div slot="acc_price" slot-scope="props">
        {{ props.item.acc_price | currency }}
      </div>

      <div slot="history" slot-scope="props">
        <button class="button" @click="openHistory(props.item.orders)">내역보기</button>
      </div>
    </admin-table>

    <modal name="historyModal"
           :adaptive="true"
           :width="900"
           :height="600"
           style="overflow-y: scroll"
           class="modal-style">
      <div class="lp-modal-wrapper">
        <div class="btn-group-justify-end" style="padding:0 12px">
          <i class="material-icons modal-exit" @click="$modal.hide('historyModal')">close</i>
        </div>
        <table class="table">
          <thead>
          <tr>
            <th>주문번호</th>
            <th>주문자</th>
            <th>상품명</th>
            <th>주문금액</th>
            <th>구매일</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(order,idx) in orders" :key="'history-'+idx">
            <td>{{ order.order_num }}</td>
            <td>{{ order.order_name }}</td>
            <!-- 주문 상품 -->
            <td>
              <div class="flex align-center" v-if="order">
                <img :src="order.product_img" style="width:35px;height:35px;margin-right:6px">
                <div style="text-align: left">
                  <div>{{ order.product_name }}</div>
                  <div v-for="(op, idx) in order.option"
                       :key="`option-${idx}`">
                    <div>옵션: {{ op.name }} / {{ op.price | currency }}</div>
                  </div>
                </div>
              </div>
            </td>
            <td>{{ order.total_price | currency }}</td>
            <td>{{ convertDate(order.created_time, 'datetime') }}</td>
          </tr>
          </tbody>
        </table>
      </div>
    </modal>
  </div>
</template>

<script>
  import ListMixin from '@/mixins/ListMixin'
  import moment from 'moment'
  export default {
    name: 'AccountAll',
    components: {},
    mixins: [
      ListMixin
    ],
    data() {
      return {
        account_id:'',
        partner_id:'',
        accountItem: undefined,
        // 정산 설정
        account_setting: {},
        orders: []
      }
    },
    created() {
      this.init();
    },
    methods: {
      init() {
        // 정산 처리 안되어있는 경우 isnull=true
        this.initializing('account_all', 'launchpack/v1/templates/account');

        if(this.isAdmin){
          this.$axios.get(this.getUrl('launchpack/v1/templates/account/setting')).then(res=>{
            this.account_setting = res.data;
          })
        }

        if(!this.isAdmin) {
          this.initField();
        }
      },
      getDataFromServer() {
        this.getData();
      },
      calcAccPrice(item) {
        return item.total_price - item.comm_price - item.coupon_price - item.point;
      },
      initField() {
        for(let i=0; i<this.tableData.length; i++){
          if(this.tableData[i].eng_name==='modify_delete') {
            this.tableData.splice(i, 1);
          }
        }
      },
      accountType0(item) {
        if(!this.account_setting.is_account) return '-';
        // 최소 금액이상 정산
        else if(this.account_setting.account_type === 1) {
          return '-'
        }
        // 날짜
        else if(this.account_setting.account_type===0) {
          return item.expect_date
        }
      },
      accountType1(item) {
        if(!this.account_setting.is_account) return '-';
        // 최소 금액이상 정산
        else if(this.account_setting.account_type === 1) {
          return this.account_setting.account_price
        }
        // 날짜
        else if(this.account_setting.account_type===0) {
          return '-'
        }
      },
      isAccountPrice(item) {
        return !item.expect_date && this.account_setting.is_account;
      },
      disableAccount(item) {
        // 날짜 기준이 아닐 경우 ( 금액 기준일 경우 )
        if(this.account_setting.is_account && this.account_setting.account_type === 1) {
          return this.calcAccPrice(item) >= this.account_setting.account_price;
        }
        else return true;
      },
      openHistory(orders) {
        this.orders = orders;
        this.$modal.show('historyModal');
      }
    }
  }
</script>

<style lang="stylus" type="stylus" scoped>
  @import '~assets/css/lp_main'

  .active
    background-color $primary
    color white

  .modal-exit
    padding 8px
    cursor pointer

  .modal-exit:hover
    color white
    background-color $primary
    border-radius 50%
</style>
